import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { SkeletonRegion, useStableKeys } from './_shared'

export interface DevicePulseSkeletonProps {
	thresholds?: number
	className?: string
	label?: string | false
}

export function DevicePulseSkeleton({
	thresholds = 4,
	className,
	label = 'Loading pulse data',
}: DevicePulseSkeletonProps) {
	const thresholdKeys = useStableKeys(thresholds)

	return (
		<SkeletonRegion
			label={label}
			className={cn('flex size-full min-h-0 flex-col gap-3 overflow-hidden px-2.5 py-2', className)}>
			{/* Fleet total */}
			<Skeleton className='h-6 w-28 shrink-0' />

			{/* Stacked bar */}
			<Skeleton className='h-7 w-full shrink-0 rounded-[6px]' />

			{/* Bucket rows — label on the left, count and share on the right */}
			<div className='flex min-h-0 flex-1 flex-col'>
				{thresholdKeys.map((key, i) => (
					<div
						key={key}
						className={cn('flex h-[36.5px] shrink-0 items-center gap-2.5 px-1', i > 0 && 'border-t border-border')}>
						<Skeleton className='size-2 shrink-0 rounded-[2px]' />
						<Skeleton className='h-3.5 flex-1 max-w-44' />
						<Skeleton className='h-3.5 w-8' />
						<Skeleton className='h-3.5 w-10' />
					</div>
				))}
			</div>
		</SkeletonRegion>
	)
}
